function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
export default (function (_ref) {
  var colors = _ref.colors,
    mediaQueries = _ref.mediaQueries;
  return {
    base: {
      color: colors.grayDarker,
      fontWeight: 500
    },
    kindH1: _defineProperty({
      fontSize: '52px',
      lineHeight: '56px',
      letterSpacing: '-.5px',
      margin: '64px 0 38px'
    }, mediaQueries.breakpointTablet, {
      fontSize: '28px',
      lineHeight: '32px',
      letterSpacing: 'normal',
      margin: '36px 0 28px'
    }),
    kindH2: _defineProperty({
      fontSize: '38px',
      lineHeight: '44px',
      letterSpacing: '-.37px',
      margin: '64px 0 38px'
    }, mediaQueries.breakpointTablet, {
      fontSize: '24px',
      lineHeight: '28px',
      letterSpacing: '-.3px',
      margin: '36px 0 28px'
    }),
    kindH3: _defineProperty({
      fontSize: '28px',
      lineHeight: '32px',
      letterSpacing: '-.27px',
      margin: '56px 0 24px'
    }, mediaQueries.breakpointTablet, {
      fontSize: '20px',
      lineHeight: '24px',
      letterSpacing: 'normal',
      margin: '36px 0 24px'
    }),
    kindH4: _defineProperty({
      fontSize: '21px',
      lineHeight: '28px',
      margin: '56px 0 24px'
    }, mediaQueries.breakpointTablet, {
      fontSize: '16px',
      lineHeight: '24px',
      letterSpacing: '-.2px',
      margin: '36px 0 24px'
    }),
    centered: {
      textAlign: 'center'
    },
    noMargin: {
      margin: 0
    }
  };
});